<template>
  <div class="about english_container">
    <myHeader />

    <!-- 创意合作伙伴部分 -->

    <div class="backgro">
      <div class="posi">
        <!-- <img src="https://download.hecoos.com/enlightv/2025-16/132418bbc1795b124de4f4aae0ebcf7a.PNG"
          class="wow fadeInUp" alt="" /> flowing-gradient-text-->
        <div class="posi_center">
          <div class="posi_Color">
            <span
              v-for="(value, index) in hecoosArray"
              :key="index"
              class="posi_font animate__animated animate__fadeInUp"
              :style="{
                'animation-delay': `${index / 8}s`,
              }"
              ><span class="color">{{ value }}</span></span
            >
          </div>
          <h1 class="posih1">
            The Unified Platform Revolutionizing Production
          </h1>
        </div>
      </div>
    </div>
    <!-- 第二屏 -->
    <div class="backgro1">
      <div>
        <div class="posi">
          <!-- <h1 class="posih1 wow fadeInUp enProductTitle">
            hecoos: The Unified Platform Revolutionizing Production
          </h1> -->
          <p class="wow fadeInUp" style="margin-bottom: 50px">
            As the world's premier production platform, we deliver integrated
            control of video broadcasting, lighting automation, interactive
            systems, mechanical orchestration, and virtual production within a
            single software ecosystem. This unified architecture enables
            end-to-end production workflow across virtual filmmaking, live
            events, and immersive experiences.
          </p>

          <p class="wow fadeInUp">
            Empowering 1000+ global projects including the Beijing 2022 Winter
            Olympics Opening Ceremony and Shenzhen TV's virtual studios, hecoos
            consolidates all broadcast capabilities into one
            platform—transforming complex workflows into single-platform
            efficiency where artistic vision achieves frame-perfect realization.
          </p>
        </div>
      </div>
    </div>

    <!-- 文化数字化的新引擎 -->
    <div class="backgro2">
      <div class="center_backgro2">
        <div class="posi">
          <!-- <h1 class="posih1 wow fadeInUp enProductTitle">
            Next-Gen Engine for Cultural Digitalization
          </h1> -->
          <p class="wow fadeInUp" style="margin-bottom: 50px">
            As an innovator in playback control systems and professional media
            servers, we deliver integrated visual solutions that streamline
            workflows, reduce costs, and enhance productivity. Our flagship
            platforms—Hirender for live performance control and hecoos for
            virtual production—consolidate all broadcast capabilities within
            single-software ecosystems, enabling end-to-end production control
            without switching platforms.
          </p>
          <p class="wow fadeInUp">
            Proven through critical roles at the Beijing 2022 Winter Olympics,
            Hangzhou 2023 Asian Games, and 2025 Osaka World Expo, our technology
            empowers professionals to execute frame-perfect productions. Built
            for demanding environments and trusted by global creators, EnlightV
            delivers the reliability that transforms creative vision into
            audience impact.
          </p>
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="clearfix" id="specific-position">
      <div class="clearfix_contain">
        <div class="left">
          <h1 class="title wow fadeInUp enProductTitle">CONTACT US</h1>
          <p class="description wow fadeInUp">
            Submit your requirements, and we will review your message carefully
            and reach out to you
          </p>
          <div
            v-for="(contact, index) in contactInfos"
            :key="index"
            class="contact-item wow fadeInUp"
          >
            <span class="ssssss wow fadeInUp">{{ contact.type }}</span>
            <span class="s1 wow fadeInUp">{{ contact.value }}</span>
          </div>
        </div>
        <!-- 发送留言 -->
        <div class="right">
          <div class="formtest">
            <div class="form-group wow fadeInUp">
              <input
                v-model="formData.name"
                type="text"
                placeholder="Your Name"
                class="form-input"
              />
            </div>
            <div class="form-group wow fadeInUp">
              <input
                v-model="formData.email"
                type="email"
                placeholder="Email Address"
                class="form-input"
              />
            </div>
            <div class="form-group wow fadeInUp">
              <textarea
                v-model="formData.content"
                placeholder="Leave a message"
                class="form-textarea"
              ></textarea>
              <div class="button-container">
                <button class="send-button1 wow fadeInUp" @click="handleSubmit">
                  Confirm Sending
                  <!-- <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 5L9 5" stroke="white" stroke-width="2" stroke-linecap="round" />
                    <path d="M6 2L9 5L6 8" stroke="white" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg> -->
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 加入我们 -->
<!--    <div class="padd">-->
<!--      <div class="job-list-container wow fadeInUp">-->
<!--        <h1 class="wow fadeInUp enProductTitle">JOIN US</h1>-->
<!--        <p class="wow fadeInUp" style="margin-bottom: 50px">-->
<!--          Welcome to submit your resume to:hr@enlightv.com-->
<!--        </p>-->
<!--        <div class="filter-section">-->
<!--          <select v-model="selectedCategory">-->
<!--            <option value="all">All positions</option>-->
<!--            &lt;!&ndash; <option value="category1">岗位类别1</option>-->
<!--              <option value="category2">岗位类别2</option> &ndash;&gt;-->
<!--            <option v-for="titleItem in newTiele" :value="titleItem">-->
<!--              {{ titleItem }}-->
<!--            </option>-->
<!--          </select>-->
<!--          <select v-model="selectedCity">-->
<!--            <option value="all">Please choose a work city</option>-->
<!--            <option v-for="cityItem in newCity" :value="cityItem">-->
<!--              {{ cityItem }}-->
<!--            </option>-->
<!--          </select>-->
<!--          &lt;!&ndash; <select v-model="selectedTime">-->
<!--              <option value="">请选择时间范围</option>-->
<!--              <option value="recent">最近一周</option>-->
<!--              <option value="month">最近一个月</option>-->
<!--            </select> &ndash;&gt;-->
<!--          <button @click="filterJobs" class="btn1">-->
<!--            <i class="iconfont icon-zaicitijiao"></i>-->
<!--            RESET-->
<!--          </button>-->
<!--        </div>-->
<!--        &lt;!&ndash; 标题 &ndash;&gt;-->
<!--        <div class="job-info1">-->
<!--          <span>TITLE</span>-->
<!--          <span>JOB CATEGORY</span>-->
<!--          <span>WORK CITY</span>-->
<!--          <span>RELEASE TIME</span>-->
<!--        </div>-->
<!--        &lt;!&ndash; 内容 &ndash;&gt;-->
<!--        <div v-if="filteredJobs.length > 0">-->
<!--          <div-->
<!--            v-for="(job, index) in filteredJobs"-->
<!--            :key="index"-->
<!--            class="job-item"-->
<!--          >-->
<!--            &lt;!&ndash; 标题 &ndash;&gt;-->
<!--            <div class="job-info">-->
<!--              <img-->
<!--                src="https://download.hecoos.com/enlightv/2025-16/f8e8a005e173c743b265a666cdd31466.png"-->
<!--                class="ss11"-->
<!--              />-->

<!--              <span class="job-name">{{ job.title }}</span>-->
<!--              <span class="job-category">{{ job.type_name }}</span>-->
<!--              <span class="job-city">{{ job.city }}</span>-->
<!--              <span class="job-time">{{ job.create_time }}</span>-->
<!--              <span-->
<!--                @click="toggleExpand(job.id)"-->
<!--                style="color: #1a90ff"-->
<!--                class="ss"-->
<!--              >-->
<!--                {{ job.isExpanded ? "Hide details" : "View details" }}</span-->
<!--              >-->
<!--              <i v-if="job.isExpanded" class="el-icon-arrow-up ss1"></i>-->
<!--              <i v-else class="el-icon-arrow-down ss1"></i>-->
<!--            </div>-->
<!--            &lt;!&ndash; 详情 &ndash;&gt;-->
<!--            <div v-show="job.isExpanded" class="job-details">-->
<!--              <h2>-->
<!--                Welcome to submit your resume to:-->
<!--                <span style="color: #1990ff">hr@enlightv.com</span>-->
<!--              </h2>-->
<!--              <h3>Job Responsibilities:</h3>-->
<!--              <div-->
<!--                class="job_hole"-->
<!--                v-html="job.duty"-->
<!--                style="-->
<!--                  font-size: 14px;-->
<!--                  color: white !important;-->
<!--                  line-height: 22px !important;-->
<!--                "-->
<!--              ></div>-->
<!--              <h3>Job requirements:</h3>-->
<!--              <div-->
<!--                class="job_hole"-->
<!--                v-html="job.condition"-->
<!--                style="-->
<!--                  font-size: 14px;-->
<!--                  color: white !important;-->
<!--                  line-height: 22px !important;-->
<!--                "-->
<!--              ></div>-->
<!--              <h3>fringe benefits:</h3>-->
<!--              <div v-html="job.welfare" class="job_hole"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; 无内容显示 &ndash;&gt;-->
<!--        <div v-else class="no_data">No positions available at the moment</div>-->
<!--      </div>-->
<!--    </div>-->

    <myFooter />
    <BackToTop></BackToTop>
    <floatingButton />
  </div>
</template>

<script>
import myHeader from "@/components/en_pc/myHeader";
import myFooter from "@/components/en_pc/myFooter";
import BackToTop from "@/components/en_pc/BackToTop";
import floatingButton from "@/components/en_pc/floatingButton";
import { getJobList, getContactUs } from "@/api/api";
import { Message } from "element-ui";

export default {
  data() {
    return {
      hecoosArray: ["h", "e", "c", "o", "o", "s"],
      isShow: false,
      jobs: [],
      newTiele: [],
      newCity: [],
      formData: {
        name: "",
        phone: "",
        email: "",
        content: "",
      },
      contactInfos: [
        { type: "EMAIL", value: "info@enlightv.com" },
        // { type: "CONSULTATION HOTLINE", value: "400-696-0726" },
        // { type: "COMPANY DIRECT MACHINE", value: "010-53608556(Monday~Friday 9:00-18:00)" },
        // { type: "QQ COMMUNICATION GROUP", value: "794369725" },
        // { type: "WECHAT CONSULTATION", value: "hecoos studio" },
      ],
      selectedCategory: "all",
      selectedCity: "all",
      // selectedTime: "",
    };
  },
  mounted() {},
  computed: {
    filteredJobs() {
      // console.log(this.filteredJobs);

      return this.jobs.filter((job) => {
        const categoryMatch =
          this.selectedCategory === "all" ||
          job.title === this.selectedCategory;
        const cityMatch =
          this.selectedCity === "all" || job.city === this.selectedCity;
        return categoryMatch && cityMatch;
      });
    },
  },
  created() {
    this.getJobInfo();
  },
  methods: {
    filterJobs() {
      this.selectedCategory = "all";
      this.selectedCity = "all";
      // this.selectedTime = "";
    },
    toggleExpand(jobId) {
      const job = this.jobs.find((item) => item.id === jobId);
      if (job) {
        job.isExpanded = !job.isExpanded;
      }
    },
    // 提交联系我们信息
    handleSubmit() {
      if (!this.formData.name) {
        Message.error("Please enter your name");
        return;
      }
      // 新增对 email 格式的校验
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!this.formData.email) {
        Message.error("Please enter your email address");
        return;
      } else if (!emailRegex.test(this.formData.email)) {
        Message.error("Please enter a valid email address");
        return;
      }
      if (!this.formData.content) {
        Message.error("Please enter the message content");
        return;
      }

      let postData = {
        ...this.formData,
      };
      getContactUs(postData).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          Message.success(res.message);
          this.formData = {};
        } else {
          Message.error(res.message);
        }
      });
    },
    // 获取招聘信息
    getJobInfo() {
      let postData = {
        limit: "10",
      };
      getJobList(postData).then((res) => {
        this.jobs = res.data;
        // 使用 forEach 遍历 jobs 数组并添加 isExpanded 属性
        this.jobs.forEach((job) => {
          this.$set(job, "isExpanded", false);
        });
        console.log(this.jobs);

        this.newTiele = this.jobs
          .map((item) => item.title)
          .filter((title, index, array) => {
            return array.indexOf(title) === index;
          });
        this.newCity = this.jobs
          .map((item) => item.city)
          .filter((city, index, array) => {
            return array.indexOf(city) === index;
          });
        // console.log(this.newCity);
      });
    },
  },
  components: { myHeader, myFooter, BackToTop, floatingButton },
};
</script>

<style scoped lang="scss">
@import "@/styles/en_pc/wsc.scss";
@import "@/styles/optimize_adaptation.scss";
.posi_Color {
  .posi_font {
    .color {
      font-size: 200px !important;
      font-weight: bold !important;
      --k: 0;
      place-self: center;
      background: linear-gradient(
        180deg,
        hsl(calc(var(--k) * 1turn), 95%, 65%),
        hsl(calc(var(--k) * 1turn + 90deg), 95%, 65%)
      );
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      // font: bold clamp(0.875em, 7.25vw, 5em);
      text-align: center;
      /* text-transform: uppercase; */
      animation: k 10s linear infinite;
    }
  }
}
.darkened-image {
  filter: brightness(0.7);
  /* 可以调整数值来控制暗度，数值越小越暗 */
}
</style>
<style>
.about .job-item .job_hole {
  color: #fff !important;
}

.about .job-item .job_hole p {
  font-size: 14px !important;
  color: #fff !important;
  /* font-family: YourFontName4 !important; */
  font-family: "roboto" !important;
  line-height: 22px !important;
}

.about .job-item .job_hole span {
  color: #fff !important;
  font-size: 14px !important;
  /* font-family: YourFontName4 !important; */
  font-family: "roboto" !important;
  line-height: 22px !important;
}

.clear_she {
  width: 20px !important;
}
.flowing-gradient-text {
  font-size: 200px !important;
  --k: 0;
  place-self: center;
  background: linear-gradient(
    90deg,
    hsl(calc(var(--k) * 1turn), 95%, 65%),
    hsl(calc(var(--k) * 1turn + 90deg), 95%, 65%)
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font: 900 clamp(0.875em, 7.25vw, 5em) arial black, sans-serif;
  text-align: center;
  /* text-transform: uppercase; */
  animation: k 4s linear infinite;
  /* font-family: "YourFontName"; */
  font-family: "roboto" !important;
}
@property --k {
  syntax: "<number>";
  initial-value: 0;
  inherits: false;
}
@keyframes k {
  to {
    --k: 1;
  }
}
</style>
